<template>
  <div class="about">
    <!-- eslint-disable prettier/prettier -->
    <h1>About Emoji-Shift:</h1>
    <p>Hi! Thank you for using my app! 😊</p>
    <p>
      Emoji-Shift is a simple Web application made using <a href="https://v3.vuejs.org/" target="_blank" rel="noopener noreferrer">Vue.js 3</a> and <a href="https://www.typescriptlang.org/" target="_blank" rel="noopener noreferrer">TypeScript</a>. It was created as a learning experience, and a gift for someone special. 🎁
    </p>
    <p>
      I am continuing to make improvements to Emoji-Shift. If you would like to check its source code, it's available at <a href="https://github.com/Fayhen/emoji-shift" target="_blank" rel="noopener noreferrer">GitHub!</a>.
    </p>
    <p>
      You can also find me at <a href="www.linkedin.com/in/diegogcsouza" target="_blank" rel="noopener noreferrer">LinkedIn</a> or <a href="https://twitter.com/Fayhen1" target="_blank" rel="noopener noreferrer">Twitter</a>.
    </p>
  </div>
</template>

<style scoped>
h1 {
  font-family: "Sansita Swashed", cursive;
}

a {
  color: #42b983;
  font-weight: 600;
}

.about {
  display: flex;
  flex-direction: column;
  width: 80%;
}
</style>
